export const ID = '62b1cc2d-95ae-4151-92c7-ad5969db7b64';

export const NAME = 'Image Grid';
